// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","contentWrapper":"Layout_contentWrapper__j8i0M"};